import { Modal } from 'carbon-components-react';
import React, { useState, useEffect } from 'react';
import Step1 from '../../Molecules/Steps/Step1';
import Step2 from '../../Molecules/Steps/Step2';
import ResponseStep from '../../Molecules/Steps/ResponseStep';
import CurrentUser from '../../Molecules/Steps/CurrentUser';
import ResponseStepExtended from '../../Molecules/Steps/ResponseStepExtended';
import { que2bValueProps } from '../../SPSSPurchaseAdvisorSelfAssessment';
import { Restart16 } from '@carbon/icons-react';
import { segmentsTracking } from 'src/common/lib/tracker';
import BusinessPartner from 'src/common/components/BusinessPartner/BusinessPartner';
import {
  externalLink,
  feature,
  spssStatsPackage,
  tileInfo,
} from 'src/apps/spss-purchase-advisor-self-assessment/constants/default';
import {
  addPath,
  checkForEComm,
  fetchCountryListFromCOS,
  WindowOpenFunction,
} from 'src/common/hooks/widgets/useLang';
import {
  convertToString,
  TranslationFunction,
} from 'src/common/hooks/widgets/useTranslation';
import { shortcode } from '../../../SPSSPurchaseAdvisorSelfAssessment.widget';

type PopUpModalProps = {
  langCode: string;
  bpName: string;
  logo: string;
  companyId: string;
  open: boolean;
  handleCloseModal: () => void;
  handleCloseQuestions: () => void;
  step: number;
  setStep: React.Dispatch<React.SetStateAction<number>>;
  que1Value: string;
  setQue1Value: React.Dispatch<React.SetStateAction<string>>;
  que2AValue: string;
  setQue2AValue: React.Dispatch<React.SetStateAction<string>>;
  que2BValue: que2bValueProps;
  setQue2BValue: React.Dispatch<React.SetStateAction<que2bValueProps>>;
  formComplete: boolean;
  drawerOpen: boolean;
  setDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setFormComplete: React.Dispatch<React.SetStateAction<boolean>>;
  handleUrxForm: () => void;
  localeCode: string;
  reset: () => void;
  tile: string;
  statsPkg: string;
  setStatsPkg: React.Dispatch<React.SetStateAction<string>>;
  setIsRequired: React.Dispatch<React.SetStateAction<boolean>>;
  isRequired: boolean;
  checkboxEdition: string;
  radioEdition: string;
  pathSelected: string;
  useTranslation: TranslationFunction;
  windowOpen: WindowOpenFunction;
  offerApplied: boolean;
  ecomm: string | undefined;
};

const Assessment = ({
  langCode,
  localeCode,
  open,
  bpName,
  logo,
  handleCloseModal,
  handleCloseQuestions,
  step,
  setStep,
  que1Value,
  setQue1Value,
  que2AValue,
  setQue2AValue,
  que2BValue,
  setQue2BValue,
  reset,
  handleUrxForm,
  tile,
  statsPkg,
  setStatsPkg,
  setIsRequired,
  isRequired,
  formComplete,
  drawerOpen,
  radioEdition,
  checkboxEdition,
  pathSelected,
  useTranslation,
  windowOpen,
  offerApplied,
  ecomm,
}: PopUpModalProps) => {
  const [picture, setPicture] = useState('');
  const [emailBtnState, setEmailBtnState] = useState(false);
  const studentsImg = 'images/Students.svg';
  const academicImg = 'images/academic.svg';
  const upgradeImg = 'images/Upgade.svg';
  const baseEditionImg = 'images/Base Edition.svg';
  const standardImg = 'images/Standard.svg';
  const professionalImg = 'images/Professional.svg';
  const premiumImg = 'images/Premium.svg';
  const baseAddonsImg = 'images/Base+addons.svg';
  const studentIconImg = 'images/Student.svg';
  const teacherIconImg = 'images/Teacher 1.svg';
  const existingUserIconImg = 'images/Exististing user.svg';
  const researchIconImg = 'images/Researcher1.svg';
  const professionalIconImg = 'images/Professional1.svg';
  const handleReset = () => {
    reset();
  };

  const [langToUse, setLangToUse] = useState<string | undefined>();

  const handleSegmentTracking = (cta: string) => {
    segmentsTracking('CTA Clicked', {
      pageTitle: 'SPSS Purchasing Advisor Self Assessment',
      object: 'SPSS Purchasing Advisor Self Assessment page',
      resultValue: 'CTA clicked',
      CTA: cta,
      location: `${pathSelected} - Next step`,
      action: '',
      field: '',
    });
  };

  // Fetch country list from COS if not provided via props
  useEffect(() => {
    fetchCountryListFromCOS(shortcode).then((countries) => {
      setLangToUse(
        countries.find((item) => item.countryLang === langCode) === undefined
          ? (countries.find((item) => item.countryLang === localeCode)
              ?.countryLang as string)
          : (countries.find((item) => item.countryLang === langCode)
              ?.countryLang as string),
      );
    });
  }, []);

  // const intl = useIntl();
  useEffect(() => {
    if (step === 1 && tile === tileInfo.tile3) {
      setPicture(studentsImg);
    } else if (step === 1 && tile === tileInfo.tile4) {
      setPicture(academicImg);
    } else if (
      step === 2 &&
      (statsPkg === 'Perpetual License' || statsPkg === 'Subscription License')
    ) {
      setPicture(upgradeImg);
    } else if (
      step === 2 &&
      statsPkg === 'Monthly & Annual Subscription License'
    ) {
      setPicture(upgradeImg);
    } else if (step === 3 && que2AValue === 'A') {
      setPicture(baseEditionImg);
    } else if (step === 3 && que2AValue === 'B') {
      setPicture(standardImg);
    } else if (step === 3 && que2AValue === 'C') {
      setPicture(professionalImg);
    } else if (step === 3 && que2AValue === 'D') {
      setPicture(premiumImg);
    } else if (
      step === 3 &&
      (que2BValue.options.Q3BA1.value ||
        que2BValue.options.Q3BA2.value ||
        que2BValue.options.Q3BA3.value ||
        que2BValue.options.Q3BA4.value)
    ) {
      setPicture(baseAddonsImg);
    }
  }, [step, statsPkg, tile]);

  useEffect(() => {
    if (!drawerOpen && !formComplete) {
      setEmailBtnState(false);
    }
  }, [drawerOpen]);

  return (
    <div className="bx--grid">
      <Modal
        open={emailBtnState ? emailBtnState : open}
        onRequestClose={handleCloseModal}
        primaryButtonText={convertToString(useTranslation('next_btn', true))}
        secondaryButtonText={convertToString(useTranslation('back_btn', true))}
        preventCloseOnClickOutside={true}
        passiveModal={
          (tile === tileInfo.tile1 || tile === tileInfo.tile2) && step === 3
            ? true
            : (tile === tileInfo.tile3 || tile === tileInfo.tile4) && step === 1
            ? true
            : tile === tileInfo.tile5 && step === 2
        }
        primaryButtonDisabled={isRequired}
        onRequestSubmit={() => {
          handleSegmentTracking('Next on step ' + step);
          setStep((step) => step + 1);
        }}
        size="lg"
        onSecondarySubmit={() => {
          if (step > 1) {
            setStep((step) => step - 1);
            handleSegmentTracking('Back on step ' + step);
          } else {
            handleCloseQuestions();
            handleSegmentTracking('Close');
            setStep(1);
          }
        }}
      >
        <div className="modal_padding">
          <div className="bx--row">
            <div className="bx--col-lg-16 bx--col-md-16 bx--col-sm-16">
              {bpName ? (
                <BusinessPartner bpName={bpName} logo={logo} urxForm={true} />
              ) : null}
            </div>
          </div>
          <div className="bx--row">
            <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-5">
              <span className="page_sub_heading">
                {useTranslation('landingText2')}
              </span>
              {(tile === tileInfo.tile1 || tile === tileInfo.tile2) &&
                step === 3 && (
                  <div className="reset-item" onClick={handleReset}>
                    <span>{useTranslation('start_over')}</span>
                    <Restart16 className="restart-icon" />
                  </div>
                )}
              {(tile === tileInfo.tile3 || tile === tileInfo.tile4) &&
                step === 1 && (
                  <div className="reset-item" onClick={handleReset}>
                    <span>{useTranslation('start_over')}</span>
                    <Restart16 className="restart-icon" />
                  </div>
                )}
              {tile === tileInfo.tile5 && step === 2 && (
                <div className="reset-item" onClick={handleReset}>
                  <span>{useTranslation('start_over')}</span>
                  <Restart16 className="restart-icon" />
                </div>
              )}
              <hr className="hr-line" />
            </div>
          </div>
          <div className="bx--row">
            <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
              {step === 1 &&
                (tile === tileInfo.tile1 || tile === tileInfo.tile2) && (
                  <Step1
                    pathSelected={pathSelected}
                    que1Value={que1Value}
                    setQue1Value={setQue1Value}
                    setQue2AValue={setQue2AValue}
                    setQue2BValue={setQue2BValue}
                    setIsRequired={setIsRequired}
                    isRequired={isRequired}
                    setStatsPkg={setStatsPkg}
                    useTranslation={useTranslation}
                  />
                )}
              {step === 2 &&
                (feature.opt1 === que1Value || feature.opt2 === que1Value) &&
                (tile === tileInfo.tile1 || tile === tileInfo.tile2) && (
                  <Step2
                    pathSelected={pathSelected}
                    que2AValue={que2AValue}
                    setQue2AValue={setQue2AValue}
                    checkbox={false}
                    que2BValue={que2BValue}
                    setQue2BValue={setQue2BValue}
                    setIsRequired={setIsRequired}
                    isRequired={isRequired}
                    que1Value={que1Value}
                    useTranslation={useTranslation}
                  />
                )}
              {step === 2 &&
                (feature.opt3 === que1Value ||
                  feature.opt4 === que1Value ||
                  feature.opt5 === que1Value ||
                  feature.opt6 === que1Value) &&
                (tile === tileInfo.tile1 || tile === tileInfo.tile2) && (
                  <Step2
                    pathSelected={pathSelected}
                    que2AValue={que2AValue}
                    setQue2AValue={setQue2AValue}
                    checkbox={true}
                    que2BValue={que2BValue}
                    setQue2BValue={setQue2BValue}
                    setIsRequired={setIsRequired}
                    isRequired={isRequired}
                    que1Value={que1Value}
                    useTranslation={useTranslation}
                  />
                )}
              {step === 1 && tile === tileInfo.tile3 && (
                <ResponseStep
                  pathSelected={pathSelected}
                  picture={picture}
                  emailSales={convertToString(
                    useTranslation('email_sale_text', true),
                  )}
                  learnMore={convertToString(
                    useTranslation('learn_more', true),
                  )}
                  title={convertToString(
                    useTranslation('std_tile_title_text', true),
                  )}
                  linkUrl={addPath(
                    langToUse ? langToUse : '',
                    externalLink.studentUrL,
                    'products',
                  )}
                  linkText={convertToString(
                    useTranslation('std_link_text', true),
                  )}
                  iconPath={studentIconImg}
                  handleUrxForm={handleUrxForm}
                  setEmailBtnState={setEmailBtnState}
                  bgColor={'#D0E2FF'}
                  useTranslation={useTranslation}
                  windowOpen={windowOpen}
                  ecomm={ecomm}
                />
              )}
              {step === 1 && tile === tileInfo.tile4 && (
                <ResponseStep
                  pathSelected={pathSelected}
                  picture={picture}
                  emailSales={convertToString(
                    useTranslation('email_sale_text', true),
                  )}
                  learnMore={convertToString(
                    useTranslation('learn_more', true),
                  )}
                  title={convertToString(
                    useTranslation('educator_tile_title_text', true),
                  )}
                  linkUrl={addPath(
                    langToUse ? langToUse : '',
                    externalLink.educatorUrL,
                    'products',
                  )}
                  linkText={convertToString(
                    useTranslation('educator_link_text', true),
                  )}
                  iconPath={teacherIconImg}
                  handleUrxForm={handleUrxForm}
                  setEmailBtnState={setEmailBtnState}
                  bgColor={'#BAE6FF'}
                  useTranslation={useTranslation}
                  windowOpen={windowOpen}
                  ecomm={ecomm}
                />
              )}
              {tile === tileInfo.tile5 && step === 1 && (
                <CurrentUser // Current User tile
                  pathSelected={pathSelected}
                  setStatsPkg={setStatsPkg}
                  statsPkg={statsPkg}
                  setIsRequired={setIsRequired}
                  setQue1Value={setQue1Value}
                  useTranslation={useTranslation}
                />
              )}
              {(statsPkg === spssStatsPackage.pkg1 ||
                statsPkg === spssStatsPackage.pkg2) &&
                step === 2 && (
                  <ResponseStep // Cuurent User option 1
                    pathSelected={pathSelected}
                    picture={picture}
                    emailSales={convertToString(
                      useTranslation('email_sale_text', true),
                    )}
                    learnMore={convertToString(
                      useTranslation('learn_more', true),
                    )}
                    title={convertToString(
                      useTranslation('perp_subs_title_text', true),
                    )}
                    linkText={convertToString(
                      useTranslation('perp_subs_link_text', true),
                    )}
                    iconPath={existingUserIconImg}
                    handleUrxForm={handleUrxForm}
                    setEmailBtnState={setEmailBtnState}
                    urx={true}
                    bgColor={'#9EF0F0'}
                    title2={convertToString(
                      useTranslation('perp_subs_title_text2', true),
                    )}
                    useTranslation={useTranslation}
                    windowOpen={windowOpen}
                    ecomm={ecomm}
                  />
                )}
              {que2AValue && step === 3 && (
                <ResponseStepExtended
                  pathSelected={pathSelected}
                  picture={picture}
                  title={convertToString(
                    useTranslation('spss_stats_pkg_text', true),
                  )}
                  edition={radioEdition}
                  linkText={convertToString(
                    useTranslation('email_sale_text', true),
                  )}
                  iconPath2={researchIconImg}
                  iconPath1={professionalIconImg}
                  purchaseText={convertToString(
                    useTranslation('purchase_text', true),
                  )}
                  checkbox={false}
                  handleUrxForm={handleUrxForm}
                  setEmailBtnState={setEmailBtnState}
                  title2={convertToString(
                    useTranslation('perp_subs_title_text2', true),
                  )}
                  useTranslation={useTranslation}
                  windowOpen={windowOpen}
                  offerApplied={offerApplied}
                  ecomm={ecomm}
                />
              )}
              {(que2BValue.options.Q3BA1.value ||
                que2BValue.options.Q3BA2.value ||
                que2BValue.options.Q3BA3.value ||
                que2BValue.options.Q3BA4.value) &&
                step === 3 && (
                  <ResponseStepExtended
                    pathSelected={pathSelected}
                    picture={picture}
                    checkbox={true}
                    title={convertToString(
                      useTranslation('spss_stats_base_title_text', true),
                    )}
                    linkUrl={externalLink.baseAddonUrl}
                    edition={checkboxEdition}
                    linkText={convertToString(
                      useTranslation(
                        `${
                          checkForEComm(ecomm, 'NA')
                            ? 'perp_subs_link_text'
                            : 'buy_now_text'
                        }`,
                        true,
                      ),
                    )}
                    iconPath2={researchIconImg}
                    iconPath1={professionalIconImg}
                    handleUrxForm={handleUrxForm}
                    setEmailBtnState={setEmailBtnState}
                    purchaseText={convertToString(
                      useTranslation('saas_purchase_text', true),
                    )}
                    useTranslation={useTranslation}
                    spss_offer_text={convertToString(
                      useTranslation('spss_offer_text', true),
                    )}
                    spss_offer_action={convertToString(
                      useTranslation('spss_offer_action', true),
                    )}
                    windowOpen={windowOpen}
                    offerApplied={offerApplied}
                    ecomm={ecomm}
                  />
                )}
              {statsPkg === spssStatsPackage.pkg3 && step === 2 && (
                <ResponseStep
                  pathSelected={pathSelected}
                  picture={picture}
                  emailSales={convertToString(
                    useTranslation('email_sale_text', true),
                  )}
                  learnMore={convertToString(
                    useTranslation('learn_more', true),
                  )}
                  title={convertToString(useTranslation('buy_now_text', true))}
                  linkUrl={externalLink.myIBM}
                  linkText={convertToString(
                    useTranslation(
                      `${
                        checkForEComm(ecomm, 'NA')
                          ? 'perp_subs_link_text'
                          : 'sass_link_text'
                      }`,
                      true,
                    ),
                  )}
                  iconPath={existingUserIconImg}
                  handleUrxForm={handleUrxForm}
                  setEmailBtnState={setEmailBtnState}
                  bgColor={'#9EF0F0'}
                  useTranslation={useTranslation}
                  ecomm={ecomm}
                />
              )}
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Assessment;
